import { traceHandle } from '../tracing'
import { withGlobalOptions } from '../types'
import { attributesUpdate } from './attributes-update'
import { buyNow } from './buy-now'
import { buyerIdentityUpdate } from './buyer-update'
import { createCart } from './create'
import { applyDiscount } from './discount-apply'
import { fetchCart } from './fetch'
import { applyGiftCard } from './giftcard-apply'
import { createCartLine } from './line-create'
import { removeCartLine } from './line-remove'
import { updateCartLine } from './line-update'

const cartAttributes = { 'shopify.api': 'storefront', 'shopify.operation': 'cart' } as const

export const cartHandles = withGlobalOptions({
  fetch: traceHandle('shopify.storefront.cart.query', cartAttributes, fetchCart),
  create: traceHandle('shopify.storefront.cart.mutate', cartAttributes, createCart),
  buyNow: traceHandle('shopify.storefront.cart.mutate', cartAttributes, buyNow),
  lineCreate: traceHandle('shopify.storefront.cart.mutate', cartAttributes, createCartLine),
  lineUpdate: traceHandle('shopify.storefront.cart.mutate', cartAttributes, updateCartLine),
  lineRemove: traceHandle('shopify.storefront.cart.mutate', cartAttributes, removeCartLine),
  discountApply: traceHandle('shopify.storefront.cart.mutate', cartAttributes, applyDiscount),
  giftCardApply: traceHandle('shopify.storefront.cart.mutate', cartAttributes, applyGiftCard),
  buyerIdentityUpdate: traceHandle(
    'shopify.storefront.cart.mutate',
    cartAttributes,
    buyerIdentityUpdate,
  ),
  attributesUpdate: traceHandle('shopify.storefront.cart.mutate', cartAttributes, attributesUpdate),
})
